/** Deep-link sob /app — board permanece montado. */
export const ROADMAP_SCHEDULE_ROUTE = '/app/agendamento-roteiro';
